function scrollToTop(cur) {
  if ($(window).width() < 1199) {
  	$('html, body').animate({
  	scrollTop: cur.offset().top - 65
  	}, 400);
  }
}

Number.prototype.countDecimals = function () {
    if(Math.floor(this.valueOf()) === this.valueOf()) return 0;
    return this.toString().split(".")[1].length || 0; 
}

function updateStepButtons() {
  var index = 1;
  var length = $('.step-wrap.visible').length;
  
	$('.step-wrap.visible').each(function() {
  	$(this).find('.step-btn').addClass('hidden');
    if (index == 1) {
    	$(this).find('.step-spacer').removeClass('hidden');
      if (index == length) {
      	$(this).find('.fin-btn').removeClass('hidden');
      } else {
      	$(this).find('.next-btn').removeClass('hidden');
      }
    } else if (index == length) {
    	$(this).find('.prev-btn').removeClass('hidden');
      $(this).find('.fin-btn').removeClass('hidden');
    } else {
      $(this).find('.prev-btn').removeClass('hidden');
      $(this).find('.next-btn').removeClass('hidden');
    }
    index += 1;
  });
}

function module(load=false) {
  var configure = $('.product-configure-module');
  if (!configure.find('input[name="lengte"]').length && !configure.find('input[name="breedte"]').length) {
    simplemodule(load);
  } else {
    
    var standaard = false;
    // var lengteT = configure.find('input[name="lengte"]').closest('.step-content-inner-sizes').data('steptype');
    // var breedteT = configure.find('input[name="breedte"]').closest('.step-content-inner-sizes').data('steptype');
    var lengteT = 'Lengte';
    var breedteT = 'Breedte';

    if (configure.find('input[name="breedte"]').length) {
      var breedte = parseFloat(configure.find('input[name="breedte"]').val().replace(',','.'));
    } else {
      var breedte = 0;
    }
    if (configure.find('input[name="lengte"]').length) {
      var lengte = parseFloat(configure.find('input[name="lengte"]').val().replace(',','.'));
      
    } else {
      var lengte = 0;
    }

    //console.log(configure.find('input[data-name="A-lengte"]').val());
    
    var totalPrice = 0;

    if ($('#maat1:checked').length) {
      var breedte = $('.standaard-sizes .size.active').attr('data-width') * 1;
      var lengte = $('.standaard-sizes .size.active').attr('data-length') * 1;
      var standaardPrice = $('.standaard-sizes .size.active').attr('data-price') * 1;
      var opstandPrice = $('.standaard-sizes .size.active').attr('data-opstand') * 1;
      standaard = true;

      configure.find('.standaard-hidden').addClass('hidden');
      configure.find('.standaard-visible').removeClass('hidden');

      configure.find('.step-function-opstand input').each(function() {
        if ($(this).attr('data-price') * 1 > 0 && opstandPrice) {
          $(this).attr('data-price', opstandPrice);
          $(this).closest('.custom-option').find('.price').text('+ ' + money(opstandPrice));
        }
      });
      

      var type = 'standaard';
      configure.find('.custom-text:not([data-option="'+ type +'"])').addClass('hidden');
      configure.find('.custom-text[data-option="'+ type +'"]').removeClass('hidden');

      showHideStepType(configure, type);


      if (!configure.find('.standaard-visible input:checked').length) {
        configure.find('.standaard-visible input[data-checked="true"]').prop('checked', true);
      }

      showChecks(configure, type);
    } else {
      configure.find('.standaard-hidden').removeClass('hidden');
      configure.find('.standaard-visible').addClass('hidden');

      configure.find('.standaard-visible input[data-checked="true"]').prop('checked', true);
      configure.find('.standaard-visible input').attr('data-checked', 'false');
      configure.find('.standaard-visible input:checked').attr('data-checked', 'true');
      configure.find('.standaard-visible input').prop('checked', false);

      var type = 'op-maat';
      configure.find('.custom-text:not([data-option="'+ type +'"])').addClass('hidden');
      configure.find('.custom-text[data-option="'+ type +'"]').removeClass('hidden');

      showHideStepType(configure, type);

      showChecks(configure, type);
    }

    

    var m2price = 0;
    if (configure.attr('data-m2price')) {
      var m2price = configure.attr('data-m2price');
    } else {
      var m2prices = JSON.parse(configure.attr('data-m2prices'));
      $.each(m2prices, function(index, value) {
        if (lengte > value.length) {
          m2price = value.price;
        }
      });
    }

    $('input[name="custom-maat"]:not(:checked), input[name="custom-rand"]:not(:checked)').closest('.size-wrap-outer').addClass('disabled');
    $('input[name="custom-maat"]:checked, input[name="custom-rand"]:checked').closest('.size-wrap-outer').removeClass('disabled');

    if (breedte && lengte) {
      configure.find('.hidden-maten-input input').val(breedteT + ': ' + breedte + ' cm, ' + lengteT + ': ' + lengte + ' cm');

      // Start Roca Online | 13-04-2023
      if(!$('input[data-name="B-lengte"]').val() || !$('input[data-name="B-breedte"]')){
        var bBreedte = 7;
        var bLengte = 7;
        var cBreedte = 3.5;
        var cLengte = 3.5;
      } else {
        var bBreedte = $('input[data-name="B-breedte"]').val();
        var bLengte = $('input[data-name="B-lengte"]').val();
        var cBreedte = $('input[data-name="C-breedte"]').val();
        var cLengte = $('input[data-name="C-lengte"]').val();
      }
      // End Roca Online | 13-04-2023
      
      fillMaatvoering(breedte, lengte, standaard);

      if (!standaard) {
        lengte += bLengte * 2 + cLengte * 2;
        breedte += bBreedte * 2 + cBreedte * 2;
      }

      if (standaardPrice) {
        var totalSize = (breedte / 100) * (lengte / 100)
        totalPrice += standaardPrice;
      } else {
        // Sart Roca Online | 13-04-2023
        //var lengteTotaal = lengte + parseFloat(bLengte) + parseFloat(cLengte);
        //var breedteTotaal = breedte + parseFloat(bBreedte) + parseFloat(cBreedte);
        var lengteTotaal = lengte;
        var breedteTotaal = breedte;
        var totalSize = (lengteTotaal / 100) * (breedteTotaal / 100);
        
        // End Roca Online | 13-04-2023
        //var totalSize = (breedte / 100) * (lengte / 100)
        totalPrice += totalSize * m2price;
      }
      

      configure.find('.custom-option input[data-m2price]').each(function() {
        var extraM2Price = $(this).attr('data-m2price') * 1;
        var extraPrice = extraM2Price * totalSize;

        $(this).attr('data-price', extraPrice);
        // Start Roca Online | 13-04-2023
        //$(this).closest('.custom-option').find('label .price').removeClass('hidden').text('+ ' +money(extraPrice()));
        $(this).closest('.custom-option').find('label .price').removeClass('hidden').text('+ ' +money(extraPrice.toFixed()));
        // End Roca Online | 13-04-2023
      });

      configure.find('.custom-option input[data-prices]').each(function() {

        var priceStaffels = JSON.parse($(this).attr('data-prices'));
        var priceStaffelsSplit = JSON.parse($(this).attr('data-split'));
        var finalIndex = 0;


        $.each(priceStaffelsSplit, function(index, split) {
          var splitNmbr = split * 1;
          if (totalSize && totalSize >= splitNmbr) {
            finalIndex = index;
          }
        });

        var extraPrice = priceStaffels[finalIndex];

        $(this).attr('data-price', extraPrice);
        $(this).closest('.custom-option').find('label .price').removeClass('hidden').text('+ ' +money(extraPrice));
      });

      configure.find('.custom-option input:checked').each(function() {
        var price = $(this).attr('data-price') * 1;

        totalPrice += price;
      });

      var extraProductPrice = 0;
      configure.find('.simple-product input:checked').each(function() {
        var price = $(this).attr('data-price') * 1;

        extraProductPrice += price;
      });
      

      var totalPriceComplete = totalPrice + extraProductPrice;
      // Start - Roca Online | 13-04-2023
      totalPriceComplete = totalPriceComplete.toFixed();
      // End - Roca Online | 13-04-2023

      configure.find('.new-price.calculate-price .price-wrap').html(money(totalPriceComplete));
      configure.attr('data-final-price', totalPrice.toFixed());

      if (load) {
        $('.price__regular .price-item--regular').text(money(totalPriceComplete));
      }
    }
  }

  hideStep();
}

function showHideStepType(configure, type) {
  configure.find('.step-wrap[data-type]:not([data-type="'+ type +'"])').each(function() {
    if (!$(this).hasClass('hidden')) {
      $(this).addClass('hidden');
      $(this).removeClass('visible');

      $(this).find('input[type="radio"]').prop('checked', false);
    }
  });
  
  configure.find('.step-wrap[data-type="'+ type +'"]').each(function() {
    if ($(this).hasClass('hidden')) {
      $(this).removeClass('hidden');
      $(this).addClass('visible');

      $(this).find('input[type="radio"]').first().prop('checked', true);
    }
  });

  updateStepNumbers(configure);
  updateStepButtons();
}

function updateStepNumbers(configure) {
  var loopIndex = 1;
  configure.find('.step-wrap.visible').each(function() {
    $(this).find('.step-title-inner-inner span').text(loopIndex);
    loopIndex += 1;
  });
}

function simplemodule(load) {
  var configure = $('.product-configure-module');
  var totalPrice = 0;
  var standaardPrice = configure.attr('data-price') * 1;

  totalPrice += standaardPrice;

  configure.find('.custom-option input[data-prices]').each(function() {

    var priceStaffels = JSON.parse($(this).attr('data-prices'));

    var extraPrice = priceStaffels[0];

    $(this).attr('data-price', extraPrice);
    $(this).closest('.custom-option').find('label .price').removeClass('hidden').text('+ ' +money(extraPrice));
  });

  configure.find('.custom-option input:checked').each(function() {
    var price = $(this).attr('data-price') * 1;

    totalPrice += price;
  });

  var extraProductPrice = 0;
  configure.find('.simple-product input:checked').each(function() {
    var price = $(this).attr('data-price') * 1;

    extraProductPrice += price;
  });
  
  configure.find('.custom-text').removeClass('hidden');

  var totalPriceComplete = totalPrice + extraProductPrice;


  configure.find('.new-price.calculate-price .price-wrap').html(money(totalPriceComplete));
  configure.attr('data-final-price', totalPrice.toFixed());

  if (load) {
    $('.price__regular .price-item--regular').text(money(standaardPrice));
  }
  
}

function fillMaatvoering(breedte, lengte, standaard) {
  var wrap = $('.step-function-maatvoering');
  var breedteMaatvoering = $('.step-function-maatvoering').find('input[data-name="A-breedte"]').val();
  var lengteMaatvoering = $('.step-function-maatvoering').find('input[data-name="A-lengte"]').val();

  if (standaard) {
    wrap.find('input').closest('.input-wrap-inner').addClass('disabled');
    wrap.find('input').closest('.input-wrap-inner input').attr('readonly', 'true');
    wrap.addClass('standaard-formaat');
  } else {
    wrap.find('input').closest('.input-wrap-inner').removeClass('disabled');
    wrap.find('input').closest('.input-wrap-inner:not(.disabled-perm) input').removeAttr('readonly');
    // wrap.find('input[data-name="A-breedte"], input[data-name="A-lengte"]').closest('.input-wrap-inner').addClass('disabled');
    wrap.removeClass('standaard-formaat');
  }

  var maatvoeringActive = $('.step-wrap.active .step-content-inner').hasClass('step-function-maatvoering');

  if (breedteMaatvoering != breedte || lengteMaatvoering != lengte) {
    if (maatvoeringActive) {
      wrap.closest('.product-configure-module').find('input[name="breedte"]').val(breedteMaatvoering);
      wrap.closest('.product-configure-module').find('input[name="lengte"]').val(lengteMaatvoering);
      wrap.closest('.product-configure-module').find('input[name="lengte"]').trigger('keyup');
    } else {
      wrap.find('input[data-name="A-breedte"]').val(breedte);
      wrap.find('input[data-name="A-lengte"]').val(lengte);

      var minValB = wrap.closest('.product-configure-module').find('input[name="breedte"]').attr('data-min');
      var maxValB = wrap.closest('.product-configure-module').find('input[name="breedte"]').attr('data-max');
      var minValL = wrap.closest('.product-configure-module').find('input[name="lengte"]').attr('data-min');
      var maxValL = wrap.closest('.product-configure-module').find('input[name="lengte"]').attr('data-max');
      wrap.find('input[data-name="A-breedte"]').attr('data-min', minValB).attr('data-max', maxValB);
      wrap.find('input[data-name="A-lengte"]').attr('data-min', minValL).attr('data-max', maxValL);

      var cSize = 3.5;

      var Bval = 7;
      /*if (standaard) {
        var Bval = 7;
      }*/
  
      wrap.find('input[data-name="B-breedte"]').val(Bval);
      wrap.find('input[data-name="B-lengte"]').val(Bval);
      wrap.find('input[data-name="B-breedte"]').attr('data-min', Bval);
      wrap.find('input[data-name="B-lengte"]').attr('data-min', Bval);
  
      wrap.find('input[data-name="C-breedte"]').val(cSize);
      wrap.find('input[data-name="C-lengte"]').val(cSize);
    }

    calculateMaatvoering(wrap);
    
  } else {
    calculateMaatvoering(wrap);
  }
  

  fillHiddenMaatvoering(wrap);
}

function calculateMaatvoering(wrap) { 
  var totalBreedte = wrap.find('input[data-name="A-breedte"]').val() * 1 + wrap.find('input[data-name="B-breedte"]').val() * 2 + wrap.find('input[data-name="C-breedte"]').val() * 2;
  var totalLengte = wrap.find('input[data-name="A-lengte"]').val() * 1 + wrap.find('input[data-name="B-lengte"]').val() * 2 + wrap.find('input[data-name="C-lengte"]').val() * 2;

  wrap.find('.result-breedte').text(totalBreedte);
  wrap.find('.result-lengte').text(totalLengte);
}

function fillHiddenMaatvoering(wrap) {
  var results = {};
  wrap.find('.input-wrap input').each(function() {
    var name = $(this).attr('name');
    var value = $(this).val();

    if (results[name]) {
      results[name].push(value);
    } else {
      results[name] = [value];
    }
    
  });

  var string = "";
  $.each(results, function(index, values) {
    string += index + ': ' + values[0] + ' cm X ' + values[1] + ' cm, ';
  });
  string = string.substring(0, string.length - 2);

  $('.hidden-specs-input-maatvoering input').val(string);
}

function checkValues(wrap, remove) {
  var correct = false;
  if (wrap.find('.size-wrap-outer').length) {
    correct = checkValuesSize(wrap, remove);
  } else if (wrap.find('.step-function-maatvoering').length) {
    correct = checkValuesMaatvoering(wrap);
  } else {
    correct = checkCheck(wrap);;
  }
  
  return correct;
}

function checkValuesSize(wrap, remove) {
  var configure = $('.product-configure-module');

  var correct = true

  if ($('#maat1:checked').length) {
    if (!$('.standaard-sizes .size.active').length){
      correct = false;
    }
  } else {
    var lengte = configure.find('input[name="lengte"]').val() * 1;
    var breedte = configure.find('input[name="breedte"]').val() * 1;
    
    var minLengte = configure.find('input[name="lengte"]').data('min') * 1;
    var maxLengte = configure.find('input[name="lengte"]').data('max') * 1;

    var minBreedte = configure.find('input[name="breedte"]').data('min') * 1;
    var maxBreedte = configure.find('input[name="breedte"]').data('max') * 1;

    
    
    if (lengte > maxLengte || lengte < minLengte) {
      correct = false;
      configure.find('input[name="lengte"]').closest('.input-wrap-inner').addClass('error');
    } else {
      configure.find('input[name="lengte"]').closest('.input-wrap-inner').removeClass('error');
    }

    if (breedte > maxBreedte || breedte < minBreedte) {
      correct = false;
      configure.find('input[name="breedte"]').closest('.input-wrap-inner').addClass('error');
    } else {
      configure.find('input[name="breedte"]').closest('.input-wrap-inner').removeClass('error');
    }
  
  }

  if (correct) {
    wrap.closest('.step-wrap').find('.step-error-basic').addClass('hidden');
  } else {
    wrap.closest('.step-wrap').find('.step-error-basic').removeClass('hidden');
  }

  return correct;
}

function checkValuesMaatvoering(wrap) {
  var correct = true;

  wrap.find('.input-wrap-inner input').each(function () {
    var value = $(this).val();
    var minVal = $(this).attr('data-min') * 1;
    var maxVal = $(this).attr('data-max') * 1;
    if ((!value) || value * 1 < minVal || value * 1 > maxVal) {
      $(this).closest('.input-wrap-inner').addClass('error');
      correct = false;
    } else {
      $(this).closest('.input-wrap-inner').removeClass('error');
    }
  });

  if (correct) {
    wrap.closest('.step-wrap').find('.step-error-basic').addClass('hidden');
  } else {
    wrap.closest('.step-wrap').find('.step-error-basic').removeClass('hidden');
  }

  return correct;
}

function checkCheck(wrap) {
  var correct = true;
  if (wrap.find('.check-melding').length && !wrap.find('.check-melding').hasClass('hidden')) {
    if (!wrap.find('.check-melding input:checked').length) {
      correct = false;
    }
  }

  if (correct) {
    wrap.closest('.step-wrap').find('.step-error-check').addClass('hidden');
  } else {
    wrap.closest('.step-wrap').find('.step-error-check').removeClass('hidden');
  }

  return correct;
}

function showMessage(cur) {
  var value = cur.val().toLowerCase();

  cur.closest('.step-wrap').find('.hidden-melding:not([data-option="'+ value +'"])').addClass('hidden');
  cur.closest('.step-wrap').find('.hidden-melding[data-option="'+ value +'"]').removeClass('hidden');

  if (cur.attr('data-price') * 1 > 0) {
    cur.closest('.step-wrap').find('.file-upload-substep').removeClass('hidden');
  } else {    
    cur.closest('.step-wrap').find('.file-upload-substep').addClass('hidden');
    if ($('.file-upload-substep').length) {
      cur.closest('.step-wrap').find('.file-upload-substep input').val('');
    }
  }
}

function showChecks(cur, standaard = false) {

  if (standaard) {
    if (standaard == 'op-maat') {
      cur.find('.check-melding[data-option="op-maat"]').removeClass('hidden');
    } else {
      cur.find('.check-melding[data-option="op-maat"]').addClass('hidden');
    }
  } else if (cur.closest('.step-wrap').find('.check-melding').attr('data-option') != 'op-maat') {
    var value = cur.val().toLowerCase();
    cur.closest('.step-wrap').find('.check-melding:not([data-option="'+ value +'"])').addClass('hidden');
    cur.closest('.step-wrap').find('.check-melding:not([data-option="'+ value +'"]) input').prop('checked', false);
    cur.closest('.step-wrap').find('.check-melding[data-option="'+ value +'"]').removeClass('hidden');
    cur.closest('.step-wrap').find('.check-melding[data-option="'+ value +'"]').closest('.step-check-outer').find('.step-subtitle').removeClass('hidden');
    cur.closest('.step-wrap').find('.check-melding:not([data-option="'+ value +'"]) input').closest('.step-check-outer').find('.step-subtitle').addClass('hidden');
  }
}

function resetFile() {
  const file = document.getElementById('bijlage');
  file.value = '';
}

function loadCartProduct(itemToLoad, item) {
  var imageHtml = '<a href="'+ item.url +'" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a><div class="cart-item__image-container gradient global-media-settings"><img src="'+ item.image +'" class="cart-item__image" alt="" loading="lazy" width="150" height="150"></div>';
  itemToLoad.find('.cart-item__media').html(imageHtml);

  itemToLoad.find('.price.price--end').text(money(item.price));

  itemToLoad.find('.cart-item__details dl').before('<a  href="'+ item.url +'" class="cart-item__name h4 break">'+ item.product_title +'</a>');
  itemToLoad.find('.cart-item__details dl').prepend('<div class="product-option"><dd>'+ item.variant +'</dd></div>');

  itemToLoad.removeClass('loading');

  var originalPrice = $('.cart__items').attr('data-total-price') / 100;
  var totalPrice = item.price * item.quantity + originalPrice;

  $('.totals__excl .totals__subtotal-value').text(money(totalPrice / 1.21));
  $('.totals__tax .totals__subtotal-value').text(money((totalPrice) - (totalPrice / 1.21)));
  $('.totals .totals__subtotal-value').text(money(totalPrice));
}

function hideStep() {
  var configure = $('.product-configure-module');
  if (configure.find('input:checked[data-hide]').length || configure.find('input:not(:checked)[data-hide]').length) {
    configure.find('input:checked[data-hide]').each(function() {
      var hideData = $(this).attr('data-hide');
      console.log('HideData1: ' + hideData);
      if (hideData.includes(',')) {
        var toHide = hideData.split(',');
      } else {
        var toHide = [hideData];
      }
      
      $.each(toHide, function(index, value) {
        var target = $('.step-function-'+value);
        target.closest('.step-wrap').addClass('hidden').removeClass('visible');
        target.find('input').prop('checked', false);
        target.find('select option').prop('selected', false);
      });
    });

    configure.find('input:not(:checked)[data-hide]').each(function() {
      
      var hideData = $(this).attr('data-hide');
      console.log('HideData2: ' + hideData);
      if (hideData.includes(',')) {
        var toHide = hideData.split(',');
      } else {
        var toHide = [hideData];
      }
      
      $.each(toHide, function(index, value) {
        var target = $('.step-function-'+value);
        target.closest('.step-wrap').removeClass('hidden').addClass('visible');
      });
    });
  }
  
}


$(document).ready(function(){
  if ($('.cart-items').length) {
    var cartUrl = $('.cart__items').attr('data-url');

    var toLoad = false;
    var itemToLoad = false;
    $('.cart-items .cart-item').each(function(index, item) {
      if($(this).find('.price.price--end').text().trim().includes('€0,00') || $(this).find('.price.price--end').text().trim().includes('-')) {
        toLoad = $(this).attr('data-id');
        itemToLoad = $(this);
        $(this).addClass('loading');
      }
    });

   if (toLoad) {
    var data = JSON.parse(sessionStorage.getItem(("variant-"+ toLoad)));
    loadCartProduct(itemToLoad, data);
    // var loadInterval = setInterval(function() {
    //   $.get(cartUrl, function(data) {
    //     $.each(data.items, function(index, item) {
    //       if (item.id == toLoad) {
    //         if (item.product_title) {
    //           loadCartProduct(itemToLoad, data, item);
    //           clearInterval(loadInterval);
    //         }
    //       }
    //     });
        

        
    //   });
    // }, 3000);
   }
   
  //  $.get(cartUrl, function(data) {
  //   console.log(data);
  // });
    
  }

  $('.configurator-submit-btn').on('click',function() {
    var cur = $(this);
    var price = $('.product-configure-module').attr('data-final-price');
    var productId = $(this).attr('data-id');
    var image = $('.product-configure-module').attr('data-image');
    var title = $('.product-configure-module').attr('data-title');
    var url = $('.product-configure-module').attr('data-url');
    var quantity = $('input[name="quantity"]').val();

    // $(this).closest('.product-form').addClass('loading');

    $.ajax({
      "url": "https://vakman.shopmonkey.nl/shopify/create/variant",
      "method": "POST",
      "timeout": 0,
      "data": {
        "product": productId,
        "price": price
      }
    }).done(function (json) {
      cur.closest('form').find('input[name="id"]').val(json.variant.id);
      console.log(json.variant);

      var data = {'id':json.variant.id, 'variant': json.variant.title, 'price': price, 'image': image, 'product_title': title, 'url': url, 'quantity': quantity};

      sessionStorage.setItem(("variant-"+ json.variant.id), JSON.stringify(data));

      var totalToAdd = $('.product-configure-module .simple-product input:checked').length;
      var totalAdded = 0;
      var started = 0;
      $('.product-configure-module .simple-product input:checked').each(function() {
        started += 1;
        var id = $(this).attr('data-vid');
        setTimeout(function(){
          $.ajax({
            "url": cur.closest('form').attr('action'),
            "method": "POST",
            "data": {
              "id": id
            }
          }).done(function () {
            totalAdded = totalAdded + 1;
          });
        }, started * 200);
      });

      if (totalToAdd > 0) {
        var mainAdded = false;
        setInterval(function () {
          if (totalToAdd == totalAdded && !mainAdded) {
            mainAdded = true;
            setTimeout(function () {
              cur.closest('form').submit();
            }, 2000 - (started * 200));
          }
        }, 200);
      } else {
        setTimeout(function () {
          cur.closest('form').submit();
        }, 1);
      }

      
    });
  });

  $('.product-configure-module .simple-product input').on('change', function() {
    module();
  });

  $('.product-configure-module .step-content-inner.step-function-maatvoering input').on('blur', function() {
    module();
  });
  
  if ($('.product-configure-module').length) {
    module(true);
    updateStepButtons();
  }
  
  $('.product-configure-module').find('.basic-step-content select, .basic-step-content input').on('change', function () {
    showChecks($(this));
    showMessage($(this));
  	module();
    updateStepButtons();
  });

  $('.product-configure-module').find('.basic-step-content select, .basic-step-content input:checked').each(function() {
    showChecks($(this));
    showMessage($(this));
  });

  $('#bijlage').on('change', function() {
    
  });
  
	$('.product-configure-module .step-wrap .step-btn .btn, .product-configure-module .custom-prev-btn').on('click', function() {
  	var way = $(this).data('way');
    var wrap = $(this).closest('.step-wrap');
    
    if (way != 'prev') {
    	var valueCheck = checkValues(wrap, false);
    } else {
    	var valueCheck = true;
    }
    
    if (valueCheck) {
      
      if (way != 'prev') {
        if ($(this).closest('.step-wrap').find('.neuten-breedte-change-message').length) {
          $(this).closest('.step-wrap').find('.neuten-breedte-change-message').addClass('hidden');
        }
      }
      
      wrap.removeClass('active');
      wrap.find('.step-content').slideUp();
      if (way == 'next') {
        wrap.addClass('visited');
        wrap.nextAll('.visible').first().addClass('active');
        wrap.nextAll('.visible').first().find('.step-content').slideDown(400, function() {
        	scrollToTop(wrap.nextAll('.visible').first());
        });
        
      } else if (way == 'prev') {
        wrap.prevAll('.visible').first().addClass('active');
        wrap.prevAll('.visible').first().find('.step-content').slideDown(400, function() {
        	scrollToTop(wrap.prevAll('.visible').first());
        });
        
      } else {
        wrap.addClass('visited');
        $('.product-form .cart .cart-btn').removeClass('hidden');
        $('.product-form .cart .add-cart.dummy-cart-btn').addClass('hidden');
        scrollToTop($('.product-configure-module'));
      }
    }
    
    
  });
  
  $('.product-configure-module .step-wrap .step-title').on('click', function() {
  	var wrap = $(this).closest('.step-wrap');
    var currentWrap = $('.product-configure-module .step-wrap.active');
    
    var prev = false;
    $('.product-configure-module .step-wrap.active').prevAll().each(function () {
    	if ($(this)[0] == wrap[0]) {
      	 prev = true;
      }
    });
    
    if ($('.product-configure-module .step-wrap.active').nextAll('.visible').first()[0] == wrap[0] || prev || !$('.product-configure-module .step-wrap.active').length || (wrap.hasClass('visited') && !wrap.hasClass('active'))) {
      $('.product-form .cart .cart-btn').addClass('hidden');
      $('.product-form .cart .add-cart.dummy-cart-btn').removeClass('hidden');
      if ($('.product-configure-module .step-wrap.active').nextAll('.visible').first()[0] == wrap[0] || (wrap.hasClass('visited') && !prev)) {
    		var valueCheck = checkValues(currentWrap, false);
      } else {
        var valueCheck = true;
      }
      
      if (valueCheck) {
        if ($('.product-configure-module .step-wrap.active').nextAll('.visible').first()[0] == wrap[0]) {
          $('.product-configure-module .step-wrap.active').addClass('visited');
        }

        $('.product-configure-module .step-wrap.active .step-content').slideUp();
        $('.product-configure-module .step-wrap').removeClass('active');

        wrap.addClass('active');
        wrap.find('.step-content').slideDown(400, function() {
        	scrollToTop(wrap);
        });;
      }
    }
  });
  
  $('.product-configure-module .size-wrap-outer input').on('focus', function() {
    $(this).closest('.input-wrap').find('#maat2, #rand2').prop('checked', true).trigger('change');
    module();
  });
  
  $('.product-configure-module .step-wrap .step-content-inner .input-wrap .input-wrap-inner input').on('focus', function (){
  	$(this).closest('.input-wrap').find('label input').trigger('click');
  });
  
  $('.product-configure-module .step-wrap .step-content-inner .standaard-sizes .sizes-wrap .size').on('click', function () {
    //console.log('test');
  	$(this).closest('.standaard-sizes').find('label input').trigger('click');
    $(this).closest('.standaard-sizes').find('.size').removeClass('active');
     $(this).closest('.standaard-sizes').find('#maat1, #rand1').prop('checked', true).trigger('change');
    // $('.product-configure-module .step-wrap .step-content-inner .standaard-sizes .sizes-wrap .size').removeClass('active');
    $(this).addClass('active');
    module();
  });
  
  $('.product-configure-module .step-wrap .step-content .step-content-inner .image-options .image-option').on('click', function () {
  	$(this).closest('.step-content-inner').find('.image-option').removeClass('active');
    $(this).addClass('active');
    
    var value = $(this).data('val');
    
    $(this).closest('.step-content').find('.select option').each(function (){
    	var optionValue = $(this).attr('value');
      if (value == optionValue) {
        
      	$(this).prop('selected', 'selected');
        $(this).closest('select').trigger('change');
      }
    });
    
    module();
  });
  
  $('.step-function-neuten .image-option').on('click', function() {
    var title = $(this).data('title');
    var info = $(this).data('info');
    
    if (info > 0) {
    	$('.step-function-hoekuitsparing').closest('.step-wrap').removeClass('hidden').addClass('visible');
      $('.extra-inputs-neuten').removeClass('hidden');
      $('.extra-inputs-neuten input').trigger('keyup');
    } else {
    	$('.step-function-hoekuitsparing').closest('.step-wrap').addClass('hidden').removeClass('visible');
      $('.extra-inputs-neuten').addClass('hidden');
      $('.hidden-neuten-input input').val('');
    }
    
    updateStepButtons();
  });
  
  $('.step-function-hoekuitsparing .image-option').on('click', function() {
  	var info = $(this).data('info');
    if (info > 0) {
    	$('.extra-inputs-hoek').removeClass('hidden');
      $('.extra-inputs-hoek input').trigger('keyup');
    } else {
    	$('.extra-inputs-hoek').addClass('hidden');
      $('.hidden-hoek-input input').val('');
    }
  });
  
  $('.step-function-maatwerk .image-option').on('click', function() {
  	var title = $(this).data('title');
    var info = $(this).data('info');
    
    var zaagsnedeFound = false;
    var zaagSnedeFirst = true;
    $('.step-function-zaagsnede .image-option').each(function () {
    	var optionInfo = $(this).data('info');
      if (title.trim() == optionInfo.trim()) {
        $(this).removeClass('hidden');
        if (zaagSnedeFirst) {
        	$(this).addClass('active');
          $(this).trigger('click');
        }
        zaagSnedeFirst = false;
      	zaagsnedeFound = true;
      } else {
      	$(this).addClass('hidden');
      }
    });
    
    if (zaagsnedeFound) {
    	$('.step-function-zaagsnede').closest('.step-wrap').removeClass('hidden').addClass('visible');
      
    } else {
    	$('.step-function-zaagsnede').closest('.step-wrap').addClass('hidden').removeClass('visible');
      $('.step-function-zaagsnede .image-option').first().trigger('click').addClass('active');
    }
    
    updateStepButtons();
    
    if (info > 0) {
    	$('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs').removeClass('hidden');
      $('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs .input-wrap').addClass('hidden');
      $('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs .input-wrap input').val('').trigger('keyup');
      $('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs').children('.input-wrap:lt('+ info +')').removeClass('hidden');
    } else {
    	$('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs').addClass('hidden');
      $('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs .input-wrap').addClass('hidden');
      $('.step-function-zaagsnede').closest('.step-wrap').find('.extra-inputs .input-wrap input').val('').trigger('keyup');
      if (lang == 'de') {
    		$('.step-function-zaagsnede').closest('.step-wrap').find('.hidden-zaagsnede-input input').val('Nicht zutreffend');
      } else {
        $('.step-function-zaagsnede').closest('.step-wrap').find('.hidden-zaagsnede-input input').val('nvt.');
      }
    }
  });
  
  $('.extra-inputs .input-wrap input').on('keyup', function (){
    var string = '';
  	$(this).closest('.step-wrap').find('.extra-inputs .input-wrap input').each(function() {
    	var name = $(this).attr('name').split('-')[0];
      var value = $(this).val();
      if (value) {
      	string += name + ': ' + value + ', ';
      }
    });
    string = string.substring(0, (string.length - 2));
    
    $(this).closest('.step-wrap').find('.hidden-input input').val(string);
  });
  
  if ($('.product-configure-module .info-popup, .price-container .info-popup, .korting-lines .info-popup').length) {
  	$('.product-configure-module .info-popup, .price-container .info-popup, .korting-lines .info-popup').each(function () {
      var href = $(this).data('href') + '?format=json';
      var cur = $(this);
      $.get(href, function(data) {
        //console.log(data);
        if (data.page.body_html) {
        	cur.html(data.page.body_html);
        } else {
        	
        }
      });
    });
  }
  
  var timeout = 0;
  $('.step-content-inner-sizes input').on('keyup webkitspeechchange', function (){
    var cur = $(this);
    var inputVal = $(this).val();
    if(inputVal.charAt(inputVal.length-1) != ',' && inputVal.charAt(inputVal.length-1) != '.'){
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function(){
        if (inputVal) {
          var localVal = parseFloat(inputVal.replace(',','.')) 
          cur.val(Math.round(localVal * 10) / 10);
          checkValues(cur.closest('.step-wrap'), true);
        }
        module();
      }, 500);
    } else if (timeout) {
      clearTimeout(timeout);
    }
  });
  
  var normalTimeout = 0;
  $('.product-configure-module').on('keyup webkitspeechchange', 'input', function (){
    var cur = $(this);
    if (!$(this).closest('.step-content-inner-sizes').length && ($(this).attr('type') == 'text' || $(this).attr('type') == 'number')) {
      var inputVal = cur.val();
    if(inputVal.charAt(inputVal.length-1) != ',' && inputVal.charAt(inputVal.length-1) != '.'){
      if (normalTimeout) {
        clearTimeout(normalTimeout);
      }
      normalTimeout = setTimeout(function(){
        if (inputVal) {
          var localVal = parseFloat(inputVal.replace(',','.')) 
          cur.val(Math.round(localVal * 10) / 10);
          checkValues(cur.closest('.step-wrap'), true);
        }
      }, 500);
    } else if (normalTimeout) {
      clearTimeout(normalTimeout);
    }
    }
  });
  
  $('input[name="custom-maat"], input[name="custom-rand"]').on('change', function() {
  	module();
  });
  
  $('[data-open-load-mobile-popup]').on('click', function() {
    var target = $(this).data('open-load-mobile-popup');
    if (!$(target).hasClass('loaded')) {
    	$(target).addClass('loaded');
      var url = $(this).data('url');
      $.get(url+ '?format=json',  function (data) {
        //console.log(data);
        $(target).find('.popup-inner').prepend('<div class="popup-header"><div class="title-small title-font">'+ data.page.title +'</div><div class="sm-close-popup hidden-sm hidden-md hidden-lg"><a href="javascript:;" class="close-mobile-popup" data-fancybox-close><i class="fa fa-times"></i></a></div></div>')
        $(target).find('.popup-inner').append('<div class="content general-content line-height">'+data.page.body_html+'</div>');
      });
    }
  });

  $('body').on('click', '.open-mobile-slide', function() {
		var cur = $(this);
		var popup = $(this).data('popup');
		if (!cur.hasClass('active')) {
			$('.mobile-popup.open').removeClass('open');
		}
		$('.mobile-popup[data-popup="' + popup + '"]').toggleClass('open');
		$('.open-mobile-slide.active').removeClass('active');
		var openPopup = $('.mobile-popup.open').data('popup');
		$('.open-mobile-slide[data-popup="' + openPopup + '"][data-main-link]').addClass('active');
	});

  $('body').on('click', '.sm-close-popup', function() {
		var popup = $(this).closest('.mobile-popup').data('popup');
		$(this).closest('.mobile-popup').removeClass('open');
		$('.open-mobile-slide[data-popup="' + popup + '"]').removeClass('active');
		setTimeout(function() {
			$('.mobile-menu .subs').removeClass('active');
		}, 200);
	});

  $('[data-fancybox]').fancybox({
		autoFocus: false,
    touch: false,
		loop: true,
		protect: true,
		infobar: true,
		buttons: [
			"close"
		],
		mobile: {
			clickContent: "close",
			clickSlide: "close"
		}
	});

  $('.input-wrap .change a').on('click', function() {
		var cur = $(this);
		var way = $(this).attr('data-way');
		updateQuantity(way, cur);
	});

});

function money(price) {
	price = parseFloat(price).toFixed(2);
	price += '';
	var x = price.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	var x3 = (x1 + x2).split('.');
	var x4 = x3[0].replace(',', '.') + ',' + x3[1];
	if (price) {
    var priceMoney = '€'+ x4;
	} else {
		var priceMoney = '';
	}
	return priceMoney;
}

function updateQuantity(way, cur) {
	var quantity = parseInt(cur.closest('.input-wrap').find('input').val());

	if (way == 'up') {
		quantity++;
	} else {
		if (quantity > 1) {
			quantity--;
		}
	}
	cur.closest('.input-wrap').find('input').val(quantity);
}